export enum SeasonSimulationState {
  Created = 'Created',
  Edited = 'Edited',
  Simulating = 'Simulating',
  Simulated = 'Simulated',
  RecalculationRequired = 'RecalculationRequired',
  Ready = 'Ready',
  Frozen = 'Frozen',
  Recalculating = 'Recalculating',
  InAllocation = 'InAllocation',
  PrePublished = 'PrePublished',
  Calculating = 'Calculating',
  CalculationRequired = 'CalculationRequired',
  Calculated = 'Calculated',
  Published = 'Published',
  UnPrePublish = 'UnPrePublish'
}
